<template>
  <WsCreate
    titleKey="name"
    :label="label"
    :fields="fields"
    :modelName="modelName"
    :primary="pageSetting.primary"
    :customCreateAction="$_customCreateAction"
  />
</template>

<script>
import model from '@/models/option';
import S_questionType from '@/services/api/v1/questionType';

export default {
  data(){
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      pageSetting: {
        primary: [
          {
            type: 'infoCard',
            floors: [
              {
                title: '角色類型資訊',
                fields: ['sequence', 'locales'],
              },
            ],
          },
        ],
      },
      singleChoiceId: null,
    }
  },
  async mounted() {
    this.singleChoiceId = await this.$_getSingleChoiceId();
  },
  methods: {
    async $_getSingleChoiceId() {
      const res = await S_questionType.index();
      const questionType = res.find(type => type.value === 'single-choice');
      return questionType.id;
    },
    $_customCreateAction(postData) {
      postData.module = 'checklist';
      postData.question_type = `${this.singleChoiceId}`;
      postData.type = 'option';
      postData.edit_risk_level = true;
      postData.edit_unit = false;
      postData.edit_in_stats = true;
    }
  }
};
</script>